import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BannerTierformMode, ConfigBannerTierListItem } from 'src/app/modules/Profile/types/agent-profile-types';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';

import { LayoutSplashScreen } from 'src/app/layout';
import { getBannerTierById } from 'src/app/modules/Profile/network/agentProfileCrud';
import BannerTierForm from './BannerTierForm';

const BannerTierDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? BannerTierformMode.EDIT : BannerTierformMode.CREATE,
    }),
    [id],
  );
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [bannerTierItem, setBannerTierItem] = useState<ConfigBannerTierListItem>();

  const reloadData = async () => {
    try {
      if (id) {
        setIsLoading(true);
        try {
          const data = await getBannerTierById(id, dispatch);

          setBannerTierItem(data);
        } catch (err) {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {formMode === BannerTierformMode.CREATE && (
        <>
          <BannerTierForm formMode={BannerTierformMode.CREATE} />
        </>
      )}
      {formMode === BannerTierformMode.EDIT &&
        (isLoading || !bannerTierItem ? (
          <LayoutSplashScreen />
        ) : (
          <>
            <BannerTierForm formMode={BannerTierformMode.EDIT} bannerTierDetail={bannerTierItem} />
          </>
        ))}
    </>
  );
};

export default BannerTierDetailPage;
